import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from '@omilia/tooltip';

import { getThemeProp } from 'theme';

import Message from './components/Message';

const StyledIconNotificationError = styled.i.attrs(() => ({
  className: 'icon-notification-error',
}))`
  color: ${getThemeProp('colors.carnationRed')};
  cursor: pointer;
  display: inline-block;
  height: 14px;
  margin-left: 10px;
`;

const DependenciesIssues = ({ issues }) => (
  <Tooltip content={<Message issues={issues} />} placement="bottom">
    <StyledIconNotificationError />
  </Tooltip>
);

DependenciesIssues.propTypes = {
  issues: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DependenciesIssues;
